import './CustomDropdown.css';
import {ReactComponent as DropdownSVG} from '../../assets/svg/dropdown.svg';

import React from 'react';

function CustomDropdown(props) {
  const [selectedOption, setSelectedOption] = React.useState(
    props.selectedValue ? props.selectedValue : 0
  );
  const [isOpen, setIsOpen] = React.useState(false);

  const clickHandler = (key) => {
    setSelectedOption(key);

    props.selectOption(props.options[key], key);
    setIsOpen(!isOpen);
  };

  const optionFormatter = (value) =>
    !props.plainText ? (
      <>
        <text
          className={`DropdownOptionsSuffix ${
            props.classNameSuffix ? props.classNameSuffix : ''
          }`}
        >
          {props.title &&
            props.title &&
            props.dropdownOptionsSuffix &&
            props.dropdownOptionsSuffix + (props.separator || ' - ')}
        </text>
        <text
          className={`DropdownOption ${
            props.classNameDpdn ? props.classNameDpdn : ''
          }`}
        >
          {value}
        </text>
      </>
    ) : (
      <text className={'DropdownOption'}>{value}</text>
    );
  return (
    <div className="dropdown" id={props.id && props.id}>
      <button
        className={`dropdown-button ${
          props.classNameD ? props.classNameD : ''
        }`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div
          className={`dropdown-body ${
            props.classNameB ? props.classNameB : ''
          }`}
        >
          {props.selectedValue !== null
            ? optionFormatter(
                props.options[
                  props.selectedValue === 0
                    ? 0
                    : props.selectedValue || selectedOption
                ]
              )
            : props.placeHolder}
        </div>
        <div className={`dropdown-svg `}>
          <DropdownSVG />
        </div>
      </button>
      {isOpen && (
        <div className={`dropdown-content`}>
          {props.options.map((option, i) => (
            <div
              key={option}
              className="dropdown-option"
              onClick={() => clickHandler(i)}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default CustomDropdown;
